const settings = [
  {
    id: 1,
    name: "ESTOQUE INICIAL (GRADE PADRÃO)",
    type: "E",
    validation: "S",
    info: false,
    price: false,
    estimate: true,
    grid: false,
  },
  {
    id: 3,
    name: "ENTRADA (GRADE ABERTA)",
    type: "E",
    validation: "S",
    info: false,
    price: false,
    estimate: false,
    grid: true,
  },
  {
    id: 4,
    name: "SAÍDA (GRADE ABERTA)",
    type: "S",
    validation: "N",
    info: false,
    price: false,
    estimate: false,
    grid: true,
  },
  {
    id: 5,
    name: "ENTRADA (GRADE FECHADA)",
    type: "E",
    validation: "N",
    info: false,
    price: false,
    estimate: false,
    grid: false,
  },
  {
    id: 6,
    name: "SAÍDA (GRADE FECHADA)",
    type: "S",
    validation: "N",
    info: false,
    price: false,
    estimate: false,
    grid: false,
  },
  {
    id: 7,
    name: "ESTOQUE INICIAL (GRADE ABERTA)",
    type: "E",
    validation: "N",
    info: false,
    price: false,
    estimate: true,
    grid: true,
  },
];

export { settings };
